import React from 'react';

import {
  infinityChecklist,
  maxChecklist,
  deafultMaxPlanCheckList,
  corePlanCheckList,
  defaultInfinityPlanChecklist
} from './checklistContent';
import css from '../SetPlan.module.scss';
import { LearnMoreTopic, Plan } from '..';
import { SavingsRewards } from '../../../../utils/prices';

interface Props {
  plan: string;
  savings: SavingsRewards;
  onLearnMoreClicked: (learnMoreTopic: LearnMoreTopic, plan: Plan) => void;
}

const planCheckListMapper = {
  max: maxChecklist,
  defaultMax: deafultMaxPlanCheckList,
  defaultInfinity: defaultInfinityPlanChecklist,
  standard: corePlanCheckList
};

const PlanChecklist = ({ plan, onLearnMoreClicked, savings }: Props) => {
  let checklist;
  if (plan === 'infinity') {
    checklist = infinityChecklist(onLearnMoreClicked);
  } else {
    checklist = planCheckListMapper[plan](savings);
  }

  const shouldRenderOptionsSubHeaders =
    plan !== 'defaultMax' && plan !== 'defaultInfinity' && plan !== 'core';
  return (
    <div className={css.checklistRedesign}>
      {shouldRenderOptionsSubHeaders && (
        <p className={css.investOptionSubheader}>All the core tools plus:</p>
      )}
      {checklist}
    </div>
  );
};

export default PlanChecklist;
